<template>
  <div class="box-detail">
    <div class="box-left">
      <div class="box-left-header">
        <div @click="$router.go(-1)" class="goBack c-position-static c-m-0">
          <i class="el-icon-arrow-left"></i>
          <span>中继号</span>
          <i class="el-icon-s-claim"></i>
        </div>
      </div>
      <div class="box-left-content">
        <c-form
          :formData="formData"
          :fields="extFields"
          :options="options"
          ref="form"
          :upload="upload"
          labelWidth="160px"
          :area="area"
          :labelPosition="'top'"
          v-if="formDataShow"
          @changeForm="osg.changeForm"
        >
          <template slot="orgIds">
            <el-cascader
              placeholder="请选择"
              v-model="formData.exts.orgIds"
              @change="
                getUsers();
                delete formData.useId;
                delete formData.usePhone;
              "
              :options="treeDataOptions"
              :props="{
                value: '_id',
                label: 'orgName',
                children: 'orgList',
                checkStrictly: true,
                expandTrigger: true
              }"
              :show-all-levels="false"
              props.checkStrictly="true"
            ></el-cascader>
          </template>
          <template slot="useId">
            <template v-if="formData.useType == '1'">
              <el-select
                v-model="formData.useId"
                :remote-method="getUsers"
                filterable
                remote
                :disabled="formData.exts.orgIds && !formData.exts.orgIds.length"
                placeholder="请选择，支持搜索"
                @change="useIdChange($event, formData.useType)"
              >
                <el-option
                  v-for="(item, i) in options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </template>

            <template v-else-if="formData.useType == '5'">
              <el-select
                v-model="formData.useId"
                :remote-method="getPartner"
                filterable
                remote
                :disabled="formData.exts.orgIds && !formData.exts.orgIds.length"
                placeholder="请选择，支持搜索"
                @change="useIdChange($event, formData.useType)"
              >
                <el-option
                  v-for="(item, i) in options.partners"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </template>
          </template>
          <template slot="startAndEndTime">
            <el-date-picker
              v-model="formData.exts.startAndEndTime"
              type="datetimerange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00']"
            ></el-date-picker>
          </template>
        </c-form>
      </div>
      <div class="box-left-footer" v-if="osg.has(`winnerLook,edit`)">
        <el-button type="primary" @click="doSave('process')">提交</el-button>
        <el-button plain @click="getData">取消</el-button>
      </div>
    </div>
    <div class="c-flex c_flex_col c-w-1">
      <div class="box-detail" style="flex: 1">
        <div class="box-center">
          <el-tabs v-model="activeTab" @tab-click="tabClick" class="c-h-1 c-flex c-flex-col">
            <el-tab-pane label="通话记录" name="callRecords">
              <div class="box-center-tool">
                <div>
                  <el-date-picker
                    v-model="callRecords.searchDate"
                    type="datetimerange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    clearable
                    @change="getCallRecords"
                    class="search-date"
                  ></el-date-picker>
                </div>
                <!-- <div>
                  <el-input
                    placeholder="请输入主叫/被叫号码"
                    v-model="callRecords.searchValue"
                    class="search-input"
                    clearable
                    @clear="getCallRecords"
                    @keyup.enter.native="getCallRecords"
                  >
                    <el-button
                      slot="append"
                      icon="el-icon-search"
                      @click="getCallRecords"
                    ></el-button>
                  </el-input>
                </div> -->
              </div>
              <div class="box-center-content">
                <div class="activity-card" v-for="(item, i) in callRecords.fpi.data" :key="i">
                  <div class="activity-card-header">
                    <span class="c-font-500">
                      <i class="el-icon-phone-outline c-w-30"></i>
                      <span v-if="item.callDirection == '0'">呼入</span>
                      <span v-else-if="item.callDirection == '1'">呼出</span>
                    </span>
                    <span>{{ formatMiddleCallResult(item.callResult) }}</span>
                  </div>
                  <div class="activity-card-content">
                    <div>
                      主叫：{{ item.callerName }}
                      {{ item.caller }}
                    </div>
                    <div>
                      被叫：{{
                        item.callWay == 4
                          ? item.calleeName || ''
                          : item.callDirection == '0'
                          ? item.calleeName || ''
                          : item.calleeName || formData.name || ''
                      }}{{ ' ' + (item.callee || '') }}
                    </div>
                    <div>
                      通话时间：{{ item.startTimeStr }} 至
                      {{ item.endTimeStr }}
                    </div>
                    <audio
                      v-if="item.recordUrl"
                      class="c-m-t-15"
                      :controlsList="osg.has('winnerLook,downloadAudio') ? null : 'nodownload'"
                      @contextmenu.prevent="osg.has('winnerLook,downloadAudio') ? true : ''"
                      controls
                      :src="item.recordUrl"
                    >
                      您的浏览器不支持 audio 标签。
                    </audio>
                  </div>
                  <div class="activity-card-footer">
                    <!-- <span>操作人：{{ item.createUserName }}</span> -->
                    <span></span>
                    <span>生成记录时间：{{ item.createTime }}</span>
                  </div>
                </div>
              </div>

              <el-pagination
                class="pagination"
                @size-change="pageSizeChange"
                @current-change="pageChange"
                :current-page="callRecords.fpi.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="callRecords.fpi.rows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="callRecords.fpi.total"
              ></el-pagination>
            </el-tab-pane>
            <el-tab-pane label="业务动态" name="log">
              <div class="box-center-tool">
                <div>
                  <el-date-picker
                    v-model="log.searchDate"
                    type="datetimerange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    clearable
                    @change="getLog"
                    class="search-date"
                  ></el-date-picker>
                </div>
                <div>
                  <el-input
                    placeholder="请输入标题/内容"
                    v-model="log.searchValue"
                    class="search-input"
                    clearable
                    @clear="getLog"
                    @keyup.enter.native="getLog"
                  >
                    <el-button slot="append" icon="el-icon-search" @click="getLog"></el-button>
                  </el-input>
                </div>
              </div>
              <div class="box-center-content">
                <div class="activity-card" v-for="(log, i) in log.fpi.data" :key="i">
                  <div class="activity-card-header">
                    <span class="c-font-500">
                      <i class="el-icon-monitor c-w-30"></i>
                      {{ log.title }}
                    </span>
                    <span>{{ log.createTime }}</span>
                  </div>
                  <div class="activity-card-content">
                    {{ log.content }}
                  </div>
                  <div class="activity-card-footer">
                    <span>操作人：{{ log.createUserName }}</span>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="笔记" name="notes" v-if="false">
              <div class="box-center-tool">
                <div></div>
                <el-button
                  type="primary"
                  size="mini"
                  @click="
                    vqeditor.content = ``;
                    openNote = true;
                  "
                >
                  创建笔记
                </el-button>
              </div>
              <div class="box-center-content">
                <div class="activity-card" v-for="(note, i) in noteData" :key="i">
                  <div class="activity-card-header">
                    <span>
                      <i class="el-icon-edit-outline c-w-30"></i>
                      笔记
                    </span>
                    <span>{{ note.createTime }}</span>
                  </div>
                  <div
                    class="activity-card-content-node"
                    v-html="note.content"
                    v-if="!note.openNote"
                  ></div>
                  <c-editor
                    v-else
                    class="c-m-15"
                    :formData="note"
                    :value="'content'"
                    ref="editor"
                  ></c-editor>
                  <div class="activity-card-footer">
                    <span>操作人：{{ note.createUserName }}</span>
                  </div>
                </div>
              </div>
              <!-- markdown编辑器 -->
              <el-dialog
                title="笔记"
                :visible.sync="openNote"
                @close="vqeditor.content = ''"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
              >
                <c-editor :formData="vqeditor" :value="'content'" ref="editor"></c-editor>
                <div slot="footer">
                  <el-button type="primary" @click="saveNote">确 认</el-button>
                  <el-button
                    @click="
                      openNote = false;
                      vqeditor.content = '';
                    "
                  >
                    取 消
                  </el-button>
                </div>
              </el-dialog>
            </el-tab-pane>

            <el-tab-pane label="操作记录" name="history">
              <div
                class="box-center-content"
                v-infinite-scroll="getHistory"
                :infinite-scroll-immediate="true"
              >
                <c-modify
                  :historyFpi="historyFpi"
                  :fields="extFields"
                  :fieldsObj="fieldsObj"
                  :options="options"
                  ref="modify"
                ></c-modify>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="box-right" :class="collapse ? 'box-collapse' : ''">
          <div class="box-right-header">
            <i class="el-icon-d-arrow-left" @click="collapse = false" v-if="collapse"></i>
            <i class="el-icon-d-arrow-right" @click="collapse = true" v-else></i>
          </div>
          <div class="box-right-content" v-show="!collapse">
            <el-collapse v-model="activeNames"></el-collapse>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'WinnerLook',
  props: {},
  components: {},
  data() {
    return {
      id: null,
      collapse: false,
      formData: { exts: {} },
      extFields: [],
      SAextFields: [], //工单扩展字段s
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      followingUpNoteExtFields: {}, //跟进记录扩展字段
      fieldsObj: {},
      options: {
        codecfg_callResult: { codeId: 'callResult' },
        codecfg_middleCallResult: { codeId: 'middleCallResult' }
      },
      rules: this.$util.rules,
      activeTab: 'callRecords',
      openNote: false,
      vqeditor: this.$util.vqeditor,
      // 通话记录
      callRecords: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      // 操作记录
      historyFpi: {
        page: 1,
        rows: 0,
        data: [],
        busy: false
      },
      historyHide: [
        'serviceAppointIds',
        'leadIds',
        'companyIds',
        'contractId',
        'insurancePolicyId',
        'province',
        'city',
        'district'
      ],
      //地址级联
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      activeNames: ['1', '2', '3', '4', '5', '6', '7'],
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      tenantId: '', //租户id
      entity: '', //
      // 日志
      log: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      editor: null,
      //全部组织
      treeDataOptions: [],
      formDataShow: false //表单显示
    };
  },
  beforeDestroy() {
    this.editor = null;
    delete this.editor;
  },
  mounted() {
    window.$this = this;
    this.id = this.osg.param('id');
    let acount = this.osg.isJson(sessionStorage['loginAccount'])
      ? JSON.parse(sessionStorage['loginAccount'])
      : {};
    this.tenantId = acount.tenantId;
    this.osg.getFields('winnerLook', () => {
      if (this.formData.useType == '5') {
        this.extFields = this.extFields
          .filter(
            item =>
              item.name != 'orgIds' &&
              item.name != 'orgName' &&
              item.name != 'field1' &&
              item.name != 'field2'
          )
          .sort((q, n) => q.order - n.order);
      }
      this.getData();
      this.getOrg();
    });
  },
  methods: {
    formatCallResult(val) {
      return this.osg.codelabel('callResult', val);
    },
    formatMiddleCallResult(val) {
      return this.osg.codelabel('middleCallResult', val);
    },
    getData() {
      this.formDataShow = false;
      var params = {
        'is:_id|string#and': this.id,
        'ne:state|array-integer#and': '-1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax('basic/winnerlook/query.do', params, async res => {
        if (Array.isArray(res.data)) {
          this.$util.renderExtField(this.extFields, res.data);
          this.formData = res.data[0];
          if (this.formData.useType == '1') {
            await this.getUsers(); //查询人员
          } else if (this.formData.useType == '5') {
            await this.getPartner(); //查询伙伴/服务商
          }
          this.getCallRecords(); //通话记录
          window.$this.$forceUpdate();
        }
        this.formDataShow = true;
      });
    },
    doSave() {
      if (this.osg.validate()) {
        let params = this.$util.deepCopy(this.formData);
        this.$util.saveFormatExtField(this.extFields, params);
        params.area = params.area || [];
        if (params.area.length > 0) {
          params.province = params.area[0] || '';
          if (params.area.length > 1) {
            params.city = params.area[1] || '';
            if (params.area.length > 2) {
              params.district = params.area[2] || '';
              if (params.area.length > 3) {
                params.subdistrict = params.area[3] || '';
              }
            }
          }
        } else {
          params.province = '';
          params.city = '';
          params.district = '';
        }
        // 赋值orgId
        if (Array.isArray(params.exts.orgIds)) {
          params.orgId = params.exts.orgIds[params.exts.orgIds.length - 1];
        }
        // 赋值useName
        if (params.useId) {
          if (this.formData.useType == '1') {
            params.useName = this.options.users.find(item => item._id == params.useId).name;
          } else if (this.formData.useType == '5') {
            params.useName = this.options.partners.find(item => item._id == params.useId).name;
          }
        }
        //解析起止时间
        if (
          Array.isArray(this.formData.exts.startAndEndTime) &&
          this.formData.exts.startAndEndTime.length
        ) {
          this.formData.startTime = this.formData.exts.startAndEndTime[0];
          this.formData.endTime = this.formData.exts.startAndEndTime[1];
        }
        this.osg.ajax('basic/winnerlook/upsert.do', { data: JSON.stringify(params) }, res => {
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    //查询人员
    getUsers(query) {
      return new Promise(resolve => {
        this.osg.ajax(
          'user/query.do',
          {
            'is:state|integer#and': '1',
            'regex:name|string#or': query,
            'regex:phone|string#or': query,
            'regex:orgName|string#or': query,
            orgId: this.formData.exts.orgIds[this.formData.exts.orgIds.length - 1],
            sortField: 'createTime',
            sortOrder: 'asc',
            page: 1,
            rows: 20
          },
          res => {
            this.options.users = res.data;
            resolve();
          },
          {
            noload: true
          }
        );
      });
    },
    //查询伙伴/服务商
    getPartner(query) {
      return new Promise(resolve => {
        this.osg.ajax(
          'basic/partner/query.do',
          {
            'is:state|integer#and': '1',
            'regex:name|string#or': query || this.formData.useName,
            'regex:phone|string#or': query,
            'regex:orgName|string#or': query,
            sortField: 'createTime',
            sortOrder: 'asc',
            page: 1,
            rows: 20
          },
          res => {
            this.options.partners = res.data;
            resolve();
          },
          {
            noload: true
          }
        );
      });
    },
    useIdChange(id, useType) {
      if (useType == '1') {
        this.formData.usePhone = this.options.users.find(item => item._id == id).phone;
      } else if (useType == '5') {
        this.formData.usePhone = this.options.partners.find(item => item._id == id).phone;
      }
      this.$forceUpdate();
    },
    pageSizeChange(pageSize) {
      this.callRecords.fpi.rows = pageSize;
      this.getCallRecords();
    },
    pageChange(currentPage) {
      this.callRecords.fpi.page = currentPage;
      this.getCallRecords();
    },
    //获取组织
    getOrg() {
      return new Promise(resolve => {
        this.osg.ajax('org/query.do', {}, res => {
          if (res.data) {
            let data = [res.data];
            this.treeData = data;
            this.treeDataOptions = this.removeEmpty(
              res.data && res.data.orgList ? res.data.orgList : []
            );
            // this.formData.description = !res.data._id ? "" : res.data._id;
            resolve();
          }
        });
      });
    },
    //删除空数组并且扁平化
    removeEmpty(arr) {
      if (Array.isArray(arr)) {
        arr.forEach(item => {
          if (item.orgList ? item.orgList.length === 0 : false) {
            delete item.orgList;
          } else {
            this.removeEmpty(item.orgList);
          }
        });
        return arr;
      }
    },
    /**
     * 切换tab页
     */
    tabClick(tab) {
      switch (tab.name) {
        case 'log':
          this.getLog();
          break;
        case 'notes':
          this.getNote();
          break;
        case 'callRecords':
          this.getCallRecords();
          break;
        case 'history':
          this.getHistory();
          break;
        default:
          return;
      }
    },
    /**
     * 日志
     */
    getLog() {
      this.log.searchDate = this.log.searchDate || [];
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: this.id,
          smodule: 'winnerlook',
          _all: '1',
          'regex:title|string#or': this.log.searchValue,
          'regex:content|string#or': this.log.searchValue,
          'gte:createTime|datetime#and': this.log.searchDate[0],
          'lte:createTime|datetime#and': this.log.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.log.fpi = res;
        },
        { noload: true }
      );
      // }
    },
    /**
     * 笔记
     */
    getNote() {
      this.osg.ajax(
        'note/query.do',
        {
          sid: this.id,
          smodule: 'contacts',
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.noteData = res || [];
        }
      );
    },
    saveNote() {
      var params = {
        //sid，smodul，content，id，isDelete(值Y) 保存传123,修改传1234,删除传12345
        sid: this.id,
        smodule: 'contacts',
        content: this.vqeditor.content
      };
      this.osg.ajax('note/upsert.do', params, () => {
        this.osg.toast('保存成功！');
        this.openNote = false;
        this.getNote();
      });
    },

    noteMdShow(note) {
      note.openNote = true;
    },
    /**
     * 通话记录
     */
    getCallRecords() {
      this.callRecords.searchDate = this.callRecords.searchDate || [];
      this.osg.ajax(
        'basic/sobot/query.do',
        {
          page: this.callRecords.fpi.page || 1,
          rows: this.callRecords.fpi.rows || 20,
          'is:callWay|integer#and': 4,
          'ne:state|array-integer#and': '-1',
          'is:middleNumber|string#and': this.formData.privateNum,
          'gte:createTime|datetime#and': this.callRecords.searchDate[0],
          'lte:createTime|datetime#and': this.callRecords.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          // contactsId
          this.callRecords.fpi = res;
        },
        { noload: true }
      );
    },
    /**
     * 操作记录
     */
    getHistory() {
      // 其他getFields查询会更新掉表单的fieldsObj
      let fieldsObj = {};
      this.extFields.map(item => {
        if (item.showList && item.showList.indexOf('6') != -1) {
          item.label = item.nameDisp;
          item.value = item.name;
          fieldsObj[item.name] = item;
        }
      });
      this.fieldsObj = fieldsObj;
      this.osg.ajax(
        'biz/changeLog/query.do',
        {
          sid: this.id,
          page: this.historyFpi.page,
          rows: (this.historyFpi.rows += 10)
        },
        res => {
          if (res) {
            if (res.data.length > 0) {
              // 不需要展示变更的字段名
              res.data.filter(item => {
                item.modifyList = item.modifyList.filter(obj => {
                  return (
                    this.fieldsObj[obj.field] &&
                    this.fieldsObj[obj.field].showList.indexOf('6') != -1
                  );
                });
                return item.modifyList.length > 0;
              });
              this.historyFpi = res;
            }
          }
        },
        { noload: true }
      );
    },
    getFields() {
      this.osg.ajax(
        'biz/ext/queryByColName/contacts.do',
        {
          _all: 1
        },
        res => {
          if (res.entity) {
            this.fields = res.entity.extFieldList;

            let fieldsObj = {};
            res.entity.extFieldList.map(item => {
              item.label = item.nameDisp;
              item.value = item.name;
              fieldsObj[item.name] = item;

              if (this.$util.isJson(item.frontEndConfig)) {
                item.frontEndConfig = JSON.parse(item.frontEndConfig);
              } else {
                item.frontEndConfig = {};
              }
              // 扩展字段支持配置是否不展示字段修改记录
              if (item.frontEndConfig.historyHide || item.type == 'file') {
                this.historyHide.push(item.name);
              }
            });
            this.options.fields = res.entity.extFieldList;
            this.fieldsObj = fieldsObj;
          }
        },
        {
          noload: true
        }
      );
    },
    formatField(row, column, cellValue) {
      return this.osg.codelabel('fields', cellValue);
    },
    formatFieldValue(row, field, cellValue) {
      if (cellValue) {
        if (this.$util.isJson(cellValue)) {
          cellValue = JSON.parse(cellValue);
        }
      }
      if (field && field.valueOption) {
        if (field.type == 'cascade') {
          if (field.frontEndConfig.multiple) {
            return this.osg.formatCascadeMultiple(field.valueOption, cellValue);
          } else {
            return this.osg.formatCascade(field.valueOption, cellValue);
          }
        } else {
          return this.osg.codelabel(field.valueOption, cellValue);
        }
      } else if (row.field == 'area' || (field && field.type == 'area')) {
        return this.formatArea(cellValue);
      } else {
        return cellValue;
      }
    }
  },
  watch: {}
};
</script>
<style lang="scss" scoped></style>
